// extracted by mini-css-extract-plugin
export default {"container":"jd3w","titleWrapper":"Qssp","title":"DMxv","iconBtn":"x_Kc","content":"fR_v","item":"rZLf","date":"w_bJ","msg":"BkbV","visibleContent":"XP9x"};